import { useParams } from 'react-router';
import { IContact } from '@/types';
import { getUrl } from '@/utils/api';

function useContact(id?: string) {
  const { contactId } = useParams();
  const query = getUrl(`v1/contacts/${id ? id : contactId}`);
  return {
    ...query,
    data: query.data as IContact,
  };
}

export default useContact;
